module.exports = __webpack_public_path__ + "static/media/default_avatar.16dd710c.png";